import { katalLogger } from '@urc-ui/services/logger/katalLogger';

/**
 * The log functions in this module emits messages to Katal. All UI code must
 * use the functions in this library.
 */

/**
 * Logs an info message.
 * @param message the info message
 * @param optionalParams any other objects to be logged
 */
const logInfoMessage = (message: string, ...optionalParams: any[]): void => {
  katalLogger.info(message, ...optionalParams);
};

/**
 * Logs a warning message.
 * @param message the warning message
 * @param optionalParams any other objects to be logged
 */
const logWarningMessage = (message: string, ...optionalParams: any[]): void => {
  katalLogger.warn(message, ...optionalParams);
};

/**
 * Logs an error message.
 * @param message the error message
 * @param optionalParams any other objects to be logged
 */
const logErrorMessage = (message: string, ...optionalParams: any[]): void => {
  katalLogger.error(message, ...optionalParams);
};

/**
 * Logs a fatal message.
 * @param message the fatal message
 * @param optionalParams any other objects to be logged
 */
const logFatalMessage = (message: string, ...optionalParams: any[]): void => {
  katalLogger.fatal(message, ...optionalParams);
};

export default {
  logWarningMessage,
  logErrorMessage,
  logInfoMessage,
  logFatalMessage
};
